export default __webpack_public_path__ + "static/media/failed.9562e178.png";